import React, { createContext, useState, useContext, useCallback, useRef } from 'react';
import NotificationToast from './Toast/Toast';
const ToastContext = createContext();

const DEFAULT_DURATION = 5000;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef({});

  const hideToast = useCallback((id) => {
    clearTimeout(timersRef.current[id]);
    delete timersRef.current[id];
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const showToast = useCallback((toast) => {
    const id = Math.floor(Math.random() * 10000000);
    const duration = toast.duration ?? DEFAULT_DURATION;
    setToasts((prevToasts) => [
      ...prevToasts,
      { id, ...toast },
    ]);
    timersRef.current[id] = setTimeout(() => hideToast(id), duration + 500);
  }, [hideToast]);

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}

      <div className="hbr-toast-stack">        
      {toasts.map((toast) => (
          <NotificationToast
            key={toast.id}
            show={true}
            bg={toast.bg}
            onClose={() => hideToast(toast.id)}
            header={toast.header}
            message={toast.message}
            duration={toast.duration}
            closable={toast.closable}
            title={toast.title}
            link={toast.link}
            linkTitle={toast.linkTitle}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);